import { styled } from 'styled-components';

const StyledTagButton = styled.button`
  display: inline-flex;
  align-items: center;
  font-size: 0.8em;
  border: 1px solid;
  border-color: ${(props) => (props.isSelected ? props.theme.colors.emphasized : props.theme.colors.text.secondary)};
  border-radius: 5px;
  box-sizing: border-box;
  margin: 2px;
  padding: 5px 10px;
  background: none;
  cursor: pointer;
  color: ${(props) => (props.isSelected ? props.theme.colors.emphasized : '')};

  &:hover {
    border-color: ${(props) => props.theme.colors.emphasized};
  }

  &:active {
    border-color: ${(props) => props.theme.colors.emphasized};
    color: ${(props) => props.theme.colors.emphasized};
  }
`;

const StyledBadge = styled.span`
  background-color: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.text.primary};
  padding: 2px 5px;
  border-radius: 10px;
  font-size: 0.8em;
  margin-left: 5px;
`;

export { StyledTagButton, StyledBadge };
